import {
  ListFilesCommandOutput,
  ListFilesCommand,
  ListFilesCommandInput,
} from "@amzn/ttechclaimintakeservice-client";

import { getAuthenticatedClient } from "../setup/getAuthenticatedClient";
import { MetricsPublisher } from "../../metrics/metrics";

export async function listFilesService(input: ListFilesCommandInput) {
  const { client } = await getAuthenticatedClient();
  if (!client) {
    return Promise.reject(new Error("Unauthorized"));
  }
  const command = new ListFilesCommand(input);
  const metricsPublisher = new MetricsPublisher("api.listFiles");

  return await client
    .send(command)
    .then((response: ListFilesCommandOutput) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderSuccessMetrics();
      return response;
    })
    .catch((error) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderFatalMetrics();
      throw error;
    });
}
